import { CurrencyInput } from '@availity/form';
import React from 'react';

interface MarketplaceCurrencyFieldProps {
    name: string;
    value: string | number;
    setFormValue: (name: string, value: string) => void;
}
export const MarketplaceCurrencyField = (
    props: MarketplaceCurrencyFieldProps
) => {
    return (
        <CurrencyInput
            name={props.name}
            value={props.value ? props.value.toString() : ''}
            allowDecimals={true}
            allowNegativeValue={false}
            prefix="$"
            onValueChanged={(value) => {
                props.setFormValue(props.name, value);
            }}
        />
    );
};
